module.exports = __webpack_public_path__ + "img/自动回复item.a33d11fa.png";